import { useQuoteCart } from "../contexts/QuoteCartContext.js";
import { CartIcon } from "../lib/icons.js";

/**
 * Tlačítko v headeru — otevírá cart drawer, zobrazuje badge s počtem.
 */
export function CartButton(): JSX.Element {
  const { itemCount, openDrawer } = useQuoteCart();
  return (
    <button
      type="button"
      onClick={openDrawer}
      aria-label={`Nabídka (${itemCount} položek)`}
      className="relative w-9 h-9 rounded-full bg-white/5 hover:bg-white/10 transition-colors flex items-center justify-center"
    >
      <CartIcon size={18} />
      {itemCount > 0 && (
        <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-ktm-orange text-white text-[10px] font-semibold flex items-center justify-center tabular-nums">
          {itemCount > 99 ? "99+" : itemCount}
        </span>
      )}
    </button>
  );
}
